console.log('custom.js loaded');

class SizeChartModal {
  constructor(data) {
    this.data = data;
    this.callback = data.callback;

    if (typeof this.callback === 'function') {
      this.callback();
    }
  }

  init() {
    console.log(this.data);

    let _this = this;
    _this.initEvents();
  }

  initEvents() {
    let _this = this;

    /* Tab Switching */
    if (_this.data.tabHeaders.length > 0) {
      _this.data.tabHeaders.forEach(tabHeader => {
        tabHeader.addEventListener("click", function (e) {
          _this.data.tabHeaders.forEach((th) => {
            th.classList.remove("active");
          });

          tabHeader.classList.add("active");

          _this.data.tabs.forEach((tab) => {
            if (tab.dataset.tabType === tabHeader.dataset.tabType) {
              tab.classList.add("active");
            } else {
              tab.classList.remove("active");
            }
          });
        });
      });
    }

    /* Measurement Switching */
    if (_this.data.measurementSwitch) {
      _this.data.measurementSwitch.addEventListener("change", function (e) {
        if (event.target.checked) {
          _this.data.modalDialog.setAttribute('data-measurement', 'metric');
        } else {
          _this.data.modalDialog.setAttribute('data-measurement', 'imperial');
        }
      });
    }

    /* How to Measure Switching */
    let htmSwitches = _this.data.modalDialog.querySelectorAll('.htm-tab-header');
    if (htmSwitches && htmSwitches.length > 0) {
      htmSwitches.forEach((htmSwitch) => {
        htmSwitch.addEventListener("click", function (e) {
          if (htmSwitch.dataset.target) {
            let grandparent = htmSwitch.parentNode.parentNode;
            grandparent.setAttribute('data-target', htmSwitch.dataset.target);
          }
        });
      });
    }

    /* Tib Tab Switching */
    let tibTabHeaders = _this.data.modalDialog.querySelectorAll('.tip-tab-header');
    if (tibTabHeaders && tibTabHeaders.length > 0) {
      tibTabHeaders.forEach((tibTabHeader) => {
        tibTabHeader.addEventListener("click", function (e) {
          tibTabHeaders.forEach((tibTabHeader) => {
            tibTabHeader.classList.remove("active");
          });

          tibTabHeader.classList.add("active");

          if (tibTabHeader.dataset.tipCount) {
            let grandparent = tibTabHeader.parentNode.parentNode;
            grandparent.setAttribute('data-active-tip-count', tibTabHeader.dataset.tipCount);
          }
        });
      });
    }

    /* Help Find My Size */
    if (_this.data.helpFindMySize) {
      _this.data.helpFindMySize.addEventListener("click", function (e) {
        e.preventDefault();

        let wairLaunchButton = document.querySelector('.wair-launch-btn');
        if (_this.data.modalClose && wairLaunchButton) {
          _this.data.modalClose.click();
          wairLaunchButton.click();
        }
      });
    }
  }
}

function initSizeChart() {
  let args = {
    modalDialog: document.querySelector('modal-dialog#PopupModal-SizeChart'),
    modalOpener: document.querySelector('modal-opener[data-modal="#PopupModal-SizeChart"]'),
    modalClose: document.querySelector('#ModalClose-SizeChart'),
    tabHeaders: document.querySelectorAll('.tab-headers .tab-header'),
    tabs: document.querySelectorAll('.tabs-container .tab'),
    measurementSwitch: document.querySelector('#measurement-switch'),
    helpFindMySize: document.querySelector('.help-find-my-size'),
    callback: sizeChartModalCallback()
  }

  window.pdpSizeChartModal = new SizeChartModal(args);
  window.pdpSizeChartModal.init();
}

function sizeChartModalCallback() {
  console.log('size chart modal callback');
}

if (window.page_template.includes('product')) {
  initSizeChart();
}

if (window.alternateHeaderHover) {
	let $body = document.body;
	let fullMenu = document.querySelector('.full-menu');
	let topLevelMenuItems = fullMenu.querySelectorAll('.thb-full-menu > li');
	let topLevelSecondaryItems = document.querySelectorAll('.thb-secondary-area .thb-secondary-area-item');
	let desktopLogo = document.querySelector('#header .logolink');

	if (desktopLogo) {
		desktopLogo.addEventListener('mouseenter', (e)=> {
			$body.classList.add('alternate-header-hover');
		});

		desktopLogo.addEventListener('mouseleave', (e)=> {
			$body.classList.remove('alternate-header-hover');
		});
	}

	if (topLevelMenuItems.length > 0) {
		topLevelMenuItems.forEach((topLevelMenuItem, index) => {
			topLevelMenuItem.addEventListener('mouseenter', (e)=> {
				$body.classList.add('alternate-header-hover');
			});

			topLevelMenuItem.addEventListener('mouseleave', (e)=> {
				$body.classList.remove('alternate-header-hover');
			});
		});
	}

	if (topLevelSecondaryItems.length > 0) {
		topLevelSecondaryItems.forEach((topLevelSecondaryItem, index) => {
			topLevelSecondaryItem.addEventListener('mouseenter', (e)=> {
				$body.classList.add('alternate-header-hover');
			});

			topLevelSecondaryItem.addEventListener('mouseleave', (e)=> {
				$body.classList.remove('alternate-header-hover');
			});
		});
	}
}

if ("register" === window.page_template || "account" === window.page_template) {
	var f = {
		getSchoolList: function () {
			var $schoolList = $("[data-school-list]");
			var prefix = "";
			if ($schoolList.length) {
				$schoolList.empty();
				if ($schoolList.data("my-school") !== undefined) {
					prefix = "student-";
				}
				$.get("//docs.google.com/spreadsheets/d/e/2PACX-1vTy2IZsn2P0MvHWCMu1QaPQZvq24ehJYviq07cqqsv55Hen4mBlHOPa_9KVo_sB6ht1_H8M8HS3bHvV/pub?output=csv", function (data) {
					var parsedData = f.parseCSV(data);
					$.each(parsedData, function (index, row) {
						if (index === 0) return true;
						var schoolCode = row[0] || "";
						var schoolName = schoolCode.replace("school_", "").split(/(?=[A-Z])/).join(" ");
						$schoolList.append("<option value='" + prefix + schoolCode + "'>" + schoolName + "</option>");
					});
					$schoolList.html($schoolList.find("option").sort(function (a, b) {
						return $(a).text() > $(b).text() ? 1 : -1;
					}));
					$schoolList.prepend("<option value='' selected='selected'>Select a School</option>");
					if ($schoolList.data("my-school") !== undefined) {
						$schoolList.val($schoolList.data("my-school"));
					}
				});
			}
		},
		parseCSV: function (t) {
			for (var e = [], i = !1, n = 0, a = 0, r = 0; r < t.length; r++) {
				var s = t[r],
					o = t[r + 1];
				e[n] = e[n] || [], e[n][a] = e[n][a] || "", '"' == s && i && '"' == o ? (e[n][a] += s, ++r) : '"' != s ? "," != s || i ? "\r" != s || "\n" != o || i ? "\n" == s && !i || "\r" == s && !i ? (++n, a = 0) : e[n][a] += s : (++n, a = 0, ++r) : ++a : i = !i
			}
			return e
		}
	};

	f.getSchoolList();
}


